import './nebula.css';
import { useNavigate } from 'react-router-dom';
import NebulaBackground from './NebulaBackground';
import NebulaNav from './NebulaNav';
import HeroSection from './hero/HeroSection';

export default function NewHomePage() {
  const navigate = useNavigate();
  const handleSignup = () => navigate('/register');
  const handleLogin = () => navigate('/login');

  return (
    <div className="nebula-page">
      <NebulaBackground />
      <NebulaNav onSignup={handleSignup} onLogin={handleLogin} />
      <HeroSection onSignup={handleSignup} />
    </div>
  );
}
